import { useMediaQuery } from "@crehana/react-hooks";
import { Skeleton } from "@crehana/ui";
import { jsx as _jsx } from "react/jsx-runtime";
var AssignedMentorsSkeleton = function AssignedMentorsSkeleton(_ref) {
  var _ref$isDark = _ref.isDark,
    isDark = _ref$isDark === void 0 ? false : _ref$isDark,
    dataTestId = _ref['data-testid'];
  var _useMediaQuery = useMediaQuery('md'),
    isMd = _useMediaQuery.matches;
  if (isMd) {
    return /*#__PURE__*/_jsx(Skeleton, {
      "data-testid": dataTestId,
      className: "w-full rounded-5",
      style: {
        height: '238px'
      },
      isDark: isDark
    });
  }
  return /*#__PURE__*/_jsx(Skeleton, {
    "data-testid": dataTestId,
    className: "w-full rounded-5",
    style: {
      height: '358px'
    },
    isDark: isDark
  });
};
export default AssignedMentorsSkeleton;